"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_barcode_1 = require("@ryerson/frontend.barcode");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var IconWrapper = styled_1.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: calc(calc(100% / 2) - ", "px);\n\ttop: calc(calc(100% / 2) - ", "px);\n\topacity: 0.8;\n"])), 12, 12);

var BarcodeScanner = function BarcodeScanner(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      handleScanResult = _ref.handleScanResult,
      handleScanError = _ref.handleScanError;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _react_1$default$useS = react_1.default.useState(""),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      scanResult = _react_1$default$useS2[0],
      setScanResult = _react_1$default$useS2[1];

  var onError = function onError(error) {
    if (error.name === "NotAllowedError") {
      setScanResult("");
      handleScanError(error.name);
    }
  };

  react_1.default.useEffect(function () {
    if (scanResult) {
      handleScanResult(scanResult);
    }
  }, [scanResult]);
  return (0, jsx_runtime_1.jsxs)("div", {
    style: {
      position: "relative"
    },
    className: "BarcodeScanner-Root ".concat(className),
    children: [(0, jsx_runtime_1.jsx)(frontend_barcode_1.BarcodeScanner, {
      onBarcode: function onBarcode(barcode) {
        var _a;

        return setScanResult((_a = barcode.replace("*", "")) === null || _a === void 0 ? void 0 : _a.replace("/J", ""));
      },
      onError: onError
    }), (0, jsx_runtime_1.jsx)(IconWrapper, {
      children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        icon: "plus",
        color: theme.colors.secondary.yellow
      })
    })]
  });
};

exports.default = BarcodeScanner;